<template>
  <div>
    <form @submit.prevent="pressOk">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <strong>Fecha de Arribo</strong>

            <input
              type="date"
              v-model="arrial_Date"
              class="form-control no-limited"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <button class="btn btn-block btn-success">
              <i class="fa fa-save"></i>

              Guardar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import toastr from "toastr";
export default {
  data() {
    return {
      apiUrl: this.$store.getters.apiUrl,
      arrial_Date: "",
    };
  },
  created() {},

  methods: {
    pressOk() {
      if (this.arrial_Date) {
        var valid = true;
        var message = "Agregue o corrija los siguiente campos:<br>";
        if (!this.arrial_Date) {
          message = message + "* Fecha real de arribo.<br>";
          valid = false;
        }
        if (valid) {
          this.$emit("pressOk", this.arrial_Date);
          this.arrial_Date = "";
        } else {
          toastr.info(message);
        }
      }
    },
  },
};
</script>


